import { Grid } from '@mui/material'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { Link, LinkType, StyledTranslationOrText } from '.'

export interface SectionLinkProps {
  id: string
  route: string
  translationId?: string
}

export const SectionLink = ({ id, route, translationId }: SectionLinkProps) => {
  return (
    <Link id={id} type={LinkType.ROUTED} to={route}>
      <Grid container alignItems="flex-start" justifyContent="right">
        <Grid item>
          <StyledTranslationOrText translationId={translationId} />
        </Grid>
        <Grid item>
          <NavigateNextIcon fontSize="medium" />
        </Grid>
      </Grid>
    </Link>
  )
}
